module.exports = __webpack_public_path__ + "img/2.50524886.png";